import { Control, UseFormTrigger, UseFormWatch } from "react-hook-form";

import {
  errorPassword,
  inputConfermaPassword,
  inputNuovaPassword,
  inputPasswordAttuale,
} from "_constants";
import { PasswordInput } from "components/shared";

export const FormUpdatePassword = ({
  control,
  watch,
  trigger,
  isPasswordValid,
  onFocusPassword,
}: {
  control: Control<
    {
      oldPassword: string;
      newPassword: string;
      confirmPassword: string;
    },
    any
  >;
  watch: UseFormWatch<{
    oldPassword: string;
    newPassword: string;
    confirmPassword: string;
  }>;
  trigger: UseFormTrigger<{
    oldPassword: string;
    newPassword: string;
    confirmPassword: string;
  }>;
  isPasswordValid: boolean;
  onFocusPassword: Function;
}) => {
  const newPass = watch("newPassword");
  const confirmPass = watch("confirmPassword");

  return (
    <>
      <div className="width-100 margin-bottom-54">
        <PasswordInput
          control={control}
          name="oldPassword"
          placeholder={inputPasswordAttuale}
          onFocusCallback={() => onFocusPassword()}
        />
        {!isPasswordValid && <small className="p-error">{errorPassword}</small>}
      </div>

      <div className="width-100 margin-bottom-8">
        <PasswordInput
          control={control}
          name="newPassword"
          feedback={true}
          placeholder={inputNuovaPassword}
          password={confirmPass}
          triggerEvent={() => trigger("confirmPassword")}
        />
      </div>
      <div className="width-100 margin-bottom-8">
        <PasswordInput
          control={control}
          name="confirmPassword"
          placeholder={inputConfermaPassword}
          password={newPass}
          triggerEvent={() => trigger("newPassword")}
        />
      </div>
    </>
  );
};
